import moment from 'moment';
import {
  getConfigApprovalBackdateJournal,
  getConfigApprovalDailyJournal,
  getWaitingJournalCount,
} from '../../../fetchAPI/finance';

const state = {
  configApprovalBackdateJournal: { role: [] },
  configApprovalDailyJournal: { role: [] },
  journalFileImport: {
    name: '',
    size: '',
    path: '',
  },
  journalListFilter: {
    type: undefined,
    user: undefined,
    status: 'not_posted',
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    dates: [],
  },
  waitingJournalCount: { notBackdate: 0, backdate: 0, total: 0 },
};

const getters = {
  getConfigApprovalBackdateJournal: (state) =>
    state.configApprovalBackdateJournal,
  getConfigApprovalDailyJournal: (state) => state.configApprovalDailyJournal,
  getJournalFileImport: (state) => state.journalFileImport,
  getJournalListFilter: (state) => state.journalListFilter,
  getWaitingJournalCount: (state) => state.waitingJournalCount,
};

const mutations = {
  setConfigApprovalBackdateJournal(state, payload) {
    state.configApprovalBackdateJournal = payload;
  },
  setConfigApprovalDailyJournal(state, payload) {
    state.configApprovalDailyJournal = payload;
  },
  setJournalFileImport(state, payload) {
    state.journalFileImport = payload;
  },
  updateJournalListFilter(state, payload) {
    state.journalListFilter = { ...state.journalListFilter, ...payload };
  },
  updateWaitingJournalCount(state, payload) {
    state.waitingJournalCount = { ...state.waitingJournalCount, ...payload };
  },
};

const actions = {
  async resolveGetConfigApprovalBackdateJournal({ commit }) {
    try {
      const responseConfigApprovalBackdateJournal =
        await getConfigApprovalBackdateJournal();

      const mapGetConfigApprovalBackdateJournal = JSON.parse(
        responseConfigApprovalBackdateJournal.value,
      );
      commit(
        'setConfigApprovalBackdateJournal',
        mapGetConfigApprovalBackdateJournal,
      );
      return responseConfigApprovalBackdateJournal;
    } catch (error) {
      return error;
    }
  },
  async resolveGetConfigApprovalDailyJournal({ commit }) {
    try {
      const responseConfigApprovalDailyJournal =
        await getConfigApprovalDailyJournal();

      const mapGetConfigApprovalDailyJournal = JSON.parse(
        responseConfigApprovalDailyJournal.value,
      );
      commit('setConfigApprovalDailyJournal', mapGetConfigApprovalDailyJournal);
      return responseConfigApprovalDailyJournal;
    } catch (error) {
      return error;
    }
  },
  async resolveGetWaitingJournalCount({ commit }) {
    try {
      const responseWaitingJournalCount = await getWaitingJournalCount();

      commit('updateWaitingJournalCount', responseWaitingJournalCount);
      return responseWaitingJournalCount;
    } catch (error) {
      return error;
    }
  },
};

export default { state, getters, mutations, actions };
